import React, { useState } from 'react';
import { Spinner } from '../../components/common';
import Header from '../../components/common/global-top-bar';
import SwitchBar from '../../components/switch-bar';
import { Headeroptions } from './common/member-constants';
import { useHistory } from 'react-router';
import RightArrow from '../../assets/images/left-arrow-symbol.svg';
import { ROUTE_PATH } from '../../routes/paths';
import moment from 'moment';
import Searchbar from '../../components/common/searchbar';
import { paramsToObjects } from '../../components/common/create-params';
import { MemberLogs, useMemberLogs, useMemberLogsCount } from '../../hooks/useMembers';
import { Paginator } from '../../components/common/paginator';
import { requireMember } from './components/require-member';

type LogFilters = {
  page: number;
  limit: number;
  search: string;
};

const Log: React.FunctionComponent = (): JSX.Element => {
  const history = useHistory();
  const { name, callerRoleId } = paramsToObjects();
  const [filters, setFilters] = useState<LogFilters>({
    page: 1,
    limit: 25,
    search: '',
  });

  const { data: logs, isLoading: isMemberLogsLoading } = useMemberLogs(callerRoleId, filters);
  const { data: count, isLoading: isMemberLogsCountLoading } = useMemberLogsCount(callerRoleId, filters);

  return (
    <div>
      {(isMemberLogsLoading || isMemberLogsCountLoading) && <Spinner />}
      <Header
        heading={
          <div className="flex w-full">
            <div
              className="mr-4 flex justify-end rounded-full bg-white"
              role="button"
              onClick={() => {
                history.push(ROUTE_PATH.MEMBERS);
              }}
            >
              <img className="h-8 w-8" src={RightArrow} alt="left Arrow"></img>
            </div>
            <p>{name || ''}</p>
          </div>
        }
      />

      <SwitchBar heading={Headeroptions} position={2} forwardParams />
      <Filters count={count?.count!} filters={filters} setFilters={setFilters} />
      <div className="bg-white pt-10"></div>
      <div className="max-window-height-table overflow-y-auto px-7 pb-10">
        <table className="table-row-format relative w-full table-fixed border-collapse">
          <thead className="h-full bg-white">
            <tr className="w-full px-7 text-left">
              <th className="sticky top-0 mb-4 h-full w-3/12 bg-white px-2 py-2">Time Stamp</th>
              <th className="sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2">Event Category</th>
              <th className="sticky top-0 mb-4 h-full w-3/12 bg-white px-2 py-2">Event Name</th>
              <th className="sticky top-0 mb-4 h-full w-5/12 bg-white px-2 py-2">Message</th>
            </tr>
          </thead>
          <tbody>
            <tr className="h-2"></tr>
            {logs &&
              logs.length > 0 &&
              logs.map((item: MemberLogs, index: number) => {
                return (
                  <tr
                    key={index}
                    className="text-gray-dark border-gray-dark h-12 space-y-6 border-b bg-white text-left"
                  >
                    <td className="w-2/12 px-2 py-1">{moment(item.timestamp).format('MMMM Do YYYY, h:mm:ss a')}</td>
                    <td className="w-1/12 px-2 py-1">{item.event_category}</td>
                    <td className="w-1/12 px-2 py-1">{item.event_name}</td>
                    <td className="w-5/12 px-2 py-1">{item.message}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

type FilterProps = {
  count: number;
  filters: LogFilters;
  setFilters: (data: LogFilters) => void;
};

const Filters: React.FunctionComponent<FilterProps> = ({ count, filters, setFilters }): JSX.Element => {
  return (
    <div className="gray-border-line bg-gray-background-light flex h-10 w-full items-center justify-start border-b px-7">
      <div className="w-1/4">
        <div className="h-8 w-full">
          <Searchbar
            search={(data) => {
              setFilters({ ...filters, search: data, page: 1 });
            }}
          />
        </div>
      </div>
      <div className="w-1/3">
        <Paginator
          count={count}
          limit={filters.limit}
          currentPage={filters.page}
          handlePageChange={(newPage) => setFilters({ ...filters, page: newPage })}
        />
      </div>
    </div>
  );
};

export default requireMember(Log);
